<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 443.979 443.979">
		<path
			d="M372.72,0H71.259c-14.48,0-26.261,11.781-26.261,26.261v391.457c0,14.48,11.78,26.261,26.261,26.261H372.72 c14.48,0,26.261-11.781,26.261-26.261V26.261C398.981,11.781,387.2,0,372.72,0z M383.981,417.718 c0,6.209-5.052,11.261-11.261,11.261H71.259c-6.209,0-11.261-5.052-11.261-11.261V26.261C59.998,20.052,65.05,15,71.259,15H372.72 c6.209,0,11.261,5.052,11.261,11.261V417.718z"
		></path>
		<path
			d="m368.982,47.908h-293.985c-2.761,0-5,2.239-5,5v338.163c0,2.761 2.239,5 5,5h293.985c2.761,0 5-2.239 5-5v-338.163c0-2.762-2.239-5-5-5zm-5,338.163h-283.985v-328.163h283.985v328.163z"
		></path>
		<path
			d="m221.992,406.478c-1.98,0-3.91,0.8-5.31,2.2-1.39,1.39-2.19,3.33-2.19,5.3 0,1.97 0.8,3.91 2.19,5.3 1.4,1.4 3.33,2.2 5.31,2.2 1.97,0 3.91-0.8 5.3-2.2 1.4-1.39 2.2-3.33 2.2-5.3 0-1.97-0.8-3.91-2.2-5.3-1.4-1.4-3.33-2.2-5.3-2.2z"
		></path>
		<path
			d="m221.992,37.248c1.31,0 2.6-0.53 3.53-1.46 0.93-0.93 1.47-2.22 1.47-3.54 0-1.32-0.54-2.6-1.47-3.54-0.93-0.93-2.22-1.46-3.53-1.46-1.32,0-2.61,0.53-3.54,1.46-0.93,0.93-1.46,2.22-1.46,3.54 0,1.32 0.53,2.61 1.46,3.54 0.93,0.93 2.22,1.46 3.54,1.46z"
		></path>
	</svg>
</div>
